export const baseUrl = process.env.REACT_APP_BASE_URI;
